import { AffiliationStatusPipe } from "./pipes/affiliation/affiliation-status.pipe";
import { CardDeliveryStatusPipe } from "./pipes/card/card-delivery-status.pipe";
import { RelationshipPipe } from "./pipes/relationship/relationship.pipe";
import { CommonModule } from "@angular/common";
import { FormatDatePipe } from "./pipes/format-date/format-date.pipe";
import { NgModule } from "@angular/core";
import { FormatStatusPipe } from "./pipes/format-status/format-status.pipe";
import { FormatStatusProcessPipe } from "./pipes/format-status-process/format-status-process.pipe";
import { FormatStatusDisaPipe } from "./pipes/format-status/format-status-disa.pipe";

@NgModule({
  declarations: [
    FormatDatePipe,
    AffiliationStatusPipe,
    CardDeliveryStatusPipe,
    RelationshipPipe,
    FormatStatusPipe,
    FormatStatusProcessPipe,
    FormatStatusDisaPipe,
  ],
  imports: [CommonModule],
  exports: [
    FormatDatePipe,
    AffiliationStatusPipe,
    CardDeliveryStatusPipe,
    RelationshipPipe,
    FormatStatusPipe,
    FormatStatusProcessPipe,
    FormatStatusDisaPipe,
  ],
})
export class CoreModule {}
